// src/components/ServiceSection.jsx
import { useState } from "react";
import { Link } from "react-router-dom";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import { servicesData } from "../../data/servicesData";

const PER_PAGE = 6;

const ServiceSection = () => {
  const [currentPage, setCurrentPage] = useState(1);

  // Map từ servicesData sang cấu trúc cần dùng
  const allServices = servicesData.map((item, index) => ({
    icon: item.icon || "01.svg", // fallback nếu chưa có icon
    title: item.title,
    slug: item.slug,
    description: item.overviewText,
    delay: `${0.3 + (index % 3) * 0.2}s`, // tự động sinh delay: .3s, .5s, .7s
  }));

  const totalPages = Math.ceil(allServices.length / PER_PAGE);

  const services = allServices.slice(
    (currentPage - 1) * PER_PAGE,
    currentPage * PER_PAGE
  );

  const goToPage = (page) => {
    if (page < 1 || page > totalPages) return;
    setCurrentPage(page);
  };

  return (
    <section className="service-section fix section-padding">
      <div className="container">
        <div className="row g-4">
          {services.map((service, index) => (
            <div
              key={index + (currentPage - 1) * PER_PAGE}
              className="col-xl-4 col-lg-6 col-md-6 wow fadeInUp"
              data-wow-delay={service.delay}
            >
              <div className="service-box-items-2 mt-0">
                <div className="icon">
                  <img
                    src={`/assets/img/icon/${service.icon}`}
                    alt={service.title}
                  />
                </div>

                <span className="number">
                  {index + 1 + (currentPage - 1) * PER_PAGE < 10
                    ? `0${index + 1 + (currentPage - 1) * PER_PAGE}`
                    : index + 1 + (currentPage - 1) * PER_PAGE}
                </span>

                <div className="content">
                  <h3>
                    <Link to={`/dich-vu/${service.slug}`}>{service.title}</Link>
                  </h3>
                  <p>{service.description}</p>
                  <div className="service-btn">
                    <Link
                      to={`/dich-vu/${service.slug}`}
                      className="link-btn"
                    >
                      Xem thêm
                    </Link>
                    <Link
                      to={`/dich-vu/${service.slug}`}
                      className="arrow-icon"
                    >
                      <img
                        src="/assets/img/icon/02.svg"
                        alt="arrow"
                      />
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Pagination */}
        <div
          className="page-nav-wrap pt-5 text-center wow fadeInUp"
          data-wow-delay=".3s"
        >
          <ul>
            <li>
              <button
                className="page-numbers icon"
                onClick={() => goToPage(currentPage - 1)}
                disabled={currentPage === 1}
              >
                <FaArrowLeft />
              </button>
            </li>
            {Array.from({ length: totalPages }).map((_, i) => (
              <li key={i}>
                <button
                  className={`page-numbers ${
                    currentPage === i + 1 ? "current" : ""
                  }`}
                  onClick={() => goToPage(i + 1)}
                >
                  {i + 1 < 10 ? `0${i + 1}` : i + 1}
                </button>
              </li>
            ))}
            <li>
              <button
                className="page-numbers icon"
                onClick={() => goToPage(currentPage + 1)}
                disabled={currentPage === totalPages}
              >
                <FaArrowRight />
              </button>
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
};

export default ServiceSection;
